import type { CSSProperties } from "react";
import type { Tag } from "schemas";
import { Button } from "./Button";
import { Card } from "./Card";
import { Markdown } from "./Markdown";
import { Tags } from "./Tags";
import { TextAccent } from "./TextAccent";

interface Props {
  label: string;
  header: string;
  description?: string | null;
  href: string;
  image?: string | null;
  tags: Tag[];
  disabled?: boolean;
  buttonBackgroundColor: string;
  buttonTextColor: string;
}

const imageStyles: CSSProperties = {
  objectFit: "cover",
  display: "block",
  width: "100%",
};

const contentContainerStyles: CSSProperties = {
  padding: "20px 20px 0",
};

const contentContainerWithImageStyles: CSSProperties = {
  ...contentContainerStyles,
  paddingTop: "8px",
};

export function AppointmentCard({
  label,
  header,
  tags,
  description,
  image,
  buttonTextColor,
  buttonBackgroundColor,
  href,
  disabled = false,
}: Props) {
  return (
    <Card>
      {image && (
        <picture>
          <source srcSet={image} type="image/webp" />
          <img style={imageStyles} src={image} alt={header} />
        </picture>
      )}
      <div style={image ? contentContainerWithImageStyles : contentContainerStyles}>
        <TextAccent>{header}</TextAccent>
        <Tags tags={tags} />
        <Markdown>{description}</Markdown>
        <Button
          disabled={disabled}
          href={href}
          buttonTextColor={buttonTextColor}
          buttonBackgroundColor={buttonBackgroundColor}
        >
          {label}
        </Button>
      </div>
    </Card>
  );
}
